
// Helper function to handle facility selection
export const handleFacilitySelected = (facilityData, setValue, stateSelectRef) => {
  // set hidden input value for hco_entity_id
  setValue('hco_entity_id', facilityData.id);
  
  // Update form fields with facility data
  setValue('address', facilityData.address || '', { shouldValidate: true });
  setValue('city', facilityData.city || '', { shouldValidate: true });
  
  // Special handling for state dropdown
  if (facilityData.state) {
    
    setValue('state', facilityData.state, { shouldValidate: true });
    
    // Update the CustomSelect component using the ref
    if (stateSelectRef.current) {
      stateSelectRef.current.setValue(facilityData.state);
    }
  }
  
  setValue('zipCode', facilityData.zip || '', { shouldValidate: true });
  setValue('phoneNumber', facilityData.phone || '', { shouldValidate: true });
};

// Event listener setup for facility selection
export const setupFacilityListener = (setValue, stateSelectRef) => {
  const listener = (event) => handleFacilitySelected(event.detail, setValue, stateSelectRef);
  document.addEventListener('facility:selected', listener);
  return () => document.removeEventListener('facility:selected', listener);
}; 